import Marionette from 'backbone.marionette'
import template from 'text-loader!templates/settings/userPlaceholder.html'

var UserPlaceholderView = Marionette.ItemView.extend({
  template: template
});

export default UserPlaceholderView;

